module.exports = __webpack_public_path__ + "static/assets/4851d7c79a543911b338f4f87a7f2f5d.png";